module.exports = __webpack_public_path__ + "static/media/final-l-en.5d6a6600.png";